import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { deleteBillingProvider } from 'api/Admin/Practice/Providers';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

import CreateUpdateBillingProvider from './CreateUpdateBillingProvider';

const Actions = ({ data }) => {
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(null);

  const navigate = useNavigate();

  const mutateDeleteBillingProvider = useCustomMutation({
    mutationFn: () => deleteBillingProvider(navigate, { id: data?.id }),
    invalidateQueryKey: ['billing-provider'],
    successMessage: 'Billing provider deleted'
  });

  const actionOptions = [
    {
      label: 'Delete',
      icon: 'trash-mono',
      onClick: () => {
        setDeleteModal(true);
      }
    },
    {
      label: 'Edit',
      icon: 'edit-2-mono',
      onClick: () => setEditModal(true)
    }
  ];

  return (
    <>
      <Popover
        isFixed
        position="left"
        isBorder={false}
        options={actionOptions}
        className="flex h-full items-center"
      />
      <CreateUpdateBillingProvider isOpen={!!editModal} handleClose={setEditModal} item={data} />
      <Confirm
        isOpen={!!deleteModal}
        title={`Delete billing provider ${data?.id}`}
        message="Are you sure you want to delete this billing provider?"
        variant="danger"
        icon="trash-mono"
        handleClose={() => setDeleteModal(false)}
        footerActions={{
          primary: {
            onClick: () => {
              mutateDeleteBillingProvider.mutate();
            },
            color: 'danger',
            isLoading: mutateDeleteBillingProvider.isLoading
          }
        }}
      />
    </>
  );
};

export default withErrorBoundary(Actions);
